export const description = {
  formacao: {
    pt: "Formada em Engenharia da Computação",
    en: "Graduated in Computer Engineering",
  },
  postGraduacao: {
    pt: "Cursando Pós-Graduação em Cloud & AI DevOps",
    en: "Studying Post-Graduation in Cloud & AI DevOps",
  },
  ingles: {
    pt: "Inglês Básico/Intermediário",
    en: "Basic/Intermediate English",
  },
  espanhol: {
    pt: "Espanhol Fluente/Nativo",
    en: "Fluent/Native Spanish",
  },
  portugues: {
    pt: "Português Fluente/Nativo",
    en: "Fluent/Native Portuguese",
  },
};
